import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const KeyboardOutlineIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2.75" y="6.25" width="18.5" height="11.5" rx="2" />
            <path d="M6.25 9.75h.5M9.75 9.75h.5M13.25 9.75h.5M16.75 9.75h.5M6.25 12.75h.5M17.25 12.75h.5M9.25 14.75h5.5" />
        </g>
    </svg>
)

const KeyboardOutlineIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {KeyboardOutlineIconSvg}
    </SvgIcon>
)

export default KeyboardOutlineIcon
